import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatNumber, htmlToPlainPreview, normalizeDescription } from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.projectManagement;
const queryKey = "projectManagement";

async function fetchProjectManagement(
  currentPage,
  search,
  status,
  is_allow_ttkq,
  isProjectMechanismParameters,
  agent,
  date
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (status) {
      options.status = status;
    }
    if (is_allow_ttkq) {
      options.is_allow_ttkq = is_allow_ttkq;
    }
     if (isProjectMechanismParameters) {
      options.isProjectMechanismParameters = isProjectMechanismParameters;
    }
    if (date) {
      const dateNumber = new Date(date);
      const month = dateNumber.getMonth() + 1;
      const year = dateNumber.getFullYear();
      options.receivedMonth = month;
      options.receivedYear = year;
    }
    if (agent) {
      options.agent = agent;
    }

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/project/?${queryParams}`);

    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const dataProjects = data?.items.map((item, index) => {
      return item?._id;
    });

    const [projectManagers] = await Promise.all([
      // clientAPI("post", "/projectDocument/getManyPath", dataProjects),
      clientAPI("post", "/projectManager/getManyPath", dataProjects),
    ]);

    let dataProjectManagers = projectManagers.map((e) => {
      if (Array.isArray(e)) {
        return e.map((item) => ({
          id: item?.id,
          managerId: item?.managerId,
          commission: item?.commission.toString(),
          participationStartDate: item?.participationStartDate,
          participationEndDate: item?.participationEndDate,
        }));
      }
      return null;
    });

    let dataProjectManagerDetails = projectManagers.map((e) => {
      if (Array.isArray(e)) {
        return e.map((item) => ({
          name: item?.manager?.fullName || "",
          position: item?.manager?.jobPosition?.name || "",
          commission: item?.commission.toString() || "",
        }));
      }
      return null;
    });
    const newData = data?.items.map((item, index) => {
      const avatarItem = item?.images?.find((item) => item.type === "AVATAR");
      const honorItem = item?.images?.find((item) => item.type === "HONOR");
      const otherItem = item?.images?.filter((img) => img.type === "OTHER");

      const imgProject =
        item?.images &&
        item?.images.length > 0 &&
        item?.images.find((item) => item.type === "AVATAR");
      return {
        id: item?._id || "",
        image: imgProject || "",
        status: item?.status || "",
        nameproject: {
          name: item?.name || "",
          des: htmlToPlainPreview(item?.description || ""),
        },
        is_allow_ttkq: item?.is_allow_ttkq || false,
        isProjectMechanismParameters: item?.isProjectMechanismParameters || false,
        investor: item?.investor?.name || "-",
        projectType: item?.projectType?.name || "-",
        agent: item?.agent || "",
        address: item?.address || "-",
        city: item?.city?.name || "-",
        received:
          item?.receivedMonth && item?.receivedYear
            ? `${item.receivedMonth}/${item?.receivedYear}`
            : "",
        commissionFromInvestor: item?.commissionFromInvestor
          ? `${item?.commissionFromInvestor}%`
          : "-",
        commissionToSales: item?.commissionToSales
          ? `${item?.commissionToSales}%`
          : "-",
        commissionFromPartner: item?.commissionFromPartner
          ? `${item?.commissionFromPartner}%`
          : "-",
        fileProject: item?.documents,
        // booking_price: item?.booking_price
        //   ? `${formatNumber(Number(item?.booking_price))} VNĐ`
        //   : "-",
        // locking_price: item?.locking_price
        //   ? `${formatNumber(Number(item?.locking_price))} VNĐ`
        //   : "-",
        edit: {
          id: item?._id || "",
          name: item?.name || "",
          description: normalizeDescription(item?.description || ""),
          investorId: item?.investorId || "",
          // kRate: item?.kRate || "0",
          projectTypeId: item?.projectTypeId || "",
          cityId: item?.cityId || "",
          address: item?.address || "",
          // nameProject: projectDocuments[index]?.name || "",
          fileProject: item?.documents,
          imageOther: otherItem || null,
          dataProjectManagers: dataProjectManagers[index],
          imageHonor: honorItem || null,
          imageProject: avatarItem || null,
          is_allow_ttkq: item?.is_allow_ttkq || false,
          // booking_price: item?.booking_price,
          // locking_price: item?.locking_price,
          agent: item?.agent || "",
          receivedMonth: item?.receivedMonth || "",
          receivedYear: item?.receivedYear || "",
          commissionFromInvestor: item?.commissionFromInvestor || 0,
          commissionToSales: item?.commissionToSales || 0,
          commissionFromPartner: item?.commissionFromPartner || 0,
        },
        detail: {
          ...item,
          id: item?._id || "",
          fileProject: item?.documents,
          // nameProject: projectDocuments[index]?.name || "",
          dataProjectManagers: dataProjectManagerDetails[index],
          imageOther: otherItem || null,
          imageHonor: honorItem || null,
          imageProject: avatarItem || null,
          is_allow_ttkq: item?.is_allow_ttkq || false,
          // booking_price: item?.booking_price
          //   ? `${formatNumber(Number(item?.booking_price))} VNĐ`
          //   : "-",
          // locking_price: item?.locking_price
          //   ? `${formatNumber(Number(item?.locking_price))} VNĐ`
          //   : "-",
          agent: item?.agent || "",
          received:
            item?.receivedMonth && item?.receivedYear
              ? `${item.receivedMonth}/${item?.receivedYear}`
              : "",
          commissionFromInvestor: item?.commissionFromInvestor
            ? `${item?.commissionFromInvestor}%`
            : "-",
          commissionToSales: item?.commissionToSales
            ? `${item?.commissionToSales}%`
            : "-",
          commissionFromPartner: item?.commissionFromPartner
            ? `${item?.commissionFromPartner}%`
            : "-",
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching attendance data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useProjectManagement(
  search,
  status,
  is_allow_ttkq,
  isProjectMechanismParameters,
  agent,
  date
) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      search,
      status,
      is_allow_ttkq,
      isProjectMechanismParameters,
      agent,
      date,
    ],
    queryFn: () =>
      fetchProjectManagement(
        currentPage,
        search,
        status,
        is_allow_ttkq,
        isProjectMechanismParameters,
        agent,
        date
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching ProjectManagement data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    projectManagementData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
